import { CertificateProgramEngagementActionType } from '@mc/api'
import { TrackingRow } from 'pages/certificates/components'
import { HeroVariant } from './HeroVariant'
import { SubscriptionSelector } from './SubscriptionSelector'
import { type HeroVariantProps } from './types'
import { getCmHeroPrices } from './utils/getCmHeroPrices'

// The BE's engagement note (details.text + a START_TRIAL "Start Course" link),
// present only for members and existing certificate customers. Rendered
// verbatim — same copy as control — so the BE stays the source of truth and the
// FE does no membership derivation.
const getEngagementNote = (props: HeroVariantProps) => {
  const details = (props.engagement ?? props.program.defaultEngagement)
    ?.actionBlock?.details
  const link = details?.link
  if (
    link?.actionType !== CertificateProgramEngagementActionType.START_TRIAL ||
    !details?.text
  ) {
    return undefined
  }
  return { text: details.text, link }
}

const HeroSelectorVariant = ({
  props,
  defaultSelection,
}: {
  props: HeroVariantProps
  defaultSelection: 'subscription' | 'individual'
}) => (
  <HeroVariant {...props} releaseLabel={props.program.releaseLabel}>
    <SubscriptionSelector
      defaultSelection={defaultSelection}
      certUuid={props.certUuid}
      engagementNote={getEngagementNote(props)}
      {...getCmHeroPrices(props.product, props.subscriptionOffer)}
    />
  </HeroVariant>
)

export const HeroVariant1 = (props: HeroVariantProps) => (
  <TrackingRow
    row_name='hero-plan-selector'
    location='hero-plan-selector'
    default_view='subscription'
    visibilityConfig={{ threshold: 0.01 }}
  >
    <HeroSelectorVariant props={props} defaultSelection='subscription' />
  </TrackingRow>
)

export const HeroVariant2 = (props: HeroVariantProps) => (
  <TrackingRow
    row_name='hero-plan-selector'
    location='hero-plan-selector'
    default_view='individual'
    visibilityConfig={{ threshold: 0.01 }}
  >
    <HeroSelectorVariant props={props} defaultSelection='individual' />
  </TrackingRow>
)
